import { calcularEdad } from '@/utils/dateUtils';

/**
 * Verifica si un descuento es válido para una fecha de nacimiento dada,
 * evaluando los límites de edad y fechas de nacimiento definidos en el descuento.
 *
 * @param {Object} descuento - Objeto de descuento con campos edad_minima, edad_maxima, fecha_nacimiento_minima, fecha_nacimiento_maxima
 * @param {string} fechaNacimiento - Fecha de nacimiento en formato YYYY-MM-DD
 * @returns {boolean} true si el descuento aplica, false en caso contrario
 */
export function esDescuentoValidoParaEdad(descuento, fechaNacimiento) {
    if (!fechaNacimiento) return true;
    const fn = new Date(fechaNacimiento);
    if (descuento.fecha_nacimiento_minima && fn < new Date(descuento.fecha_nacimiento_minima)) return false;
    if (descuento.fecha_nacimiento_maxima && fn > new Date(descuento.fecha_nacimiento_maxima)) return false;
    if (descuento.edad_minima || descuento.edad_maxima) {
        const edad = calcularEdad(fechaNacimiento);
        if (edad > 0) {
            if (descuento.edad_minima && edad < parseInt(descuento.edad_minima)) return false;
            if (descuento.edad_maxima && edad > parseInt(descuento.edad_maxima)) return false;
        }
    }
    return true;
}
